// extracted by mini-css-extract-plugin
export var dataCell = "_rg-2";
export var dataRow = "_rg-0";
export var headerRow = "_rg-1";